import Head from 'next/head';
import type { GetServerSideProps } from 'next';
import { withApollo } from '$apollo/hooks';
import { RegisterContainer } from '$pages/register';

import { withServerSkipPageIfAuthenticated } from '$util/identity';
import CustomerLayout from '$layout/CustomerLayout';
import { GET_PASSWORD_CMS_QUERY } from '$components/pages/checkout/personaldetails/gql/queries/getPasswordCmsContent';
import { QUERY_GET_FORM_CMS_CONTENT } from '$components/pages/checkout/personaldetails/gql/queries/getFormCmsContent';
import type { CmsContentProps } from '$cms/index';
import { getShortTextByKey } from '$cms/getDataByKey';
import { GET_REGISTER_PAGE_CMS_QUERY } from '$components/pages/register/gql/queries';
import { getMetaTitle } from '$components/pages/gql';

function RegisterPage({ cmsContent }: CmsContentProps) {
  const getShortText = getShortTextByKey.bind(cmsContent?.dictionary);
  const pageTitle = getShortText('metaTitle.customer.register', 'Register | Fixter');
  return (
    <CustomerLayout>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      <RegisterContainer />;
    </CustomerLayout>
  );
}

export const getServerSideProps: GetServerSideProps = withServerSkipPageIfAuthenticated([
  GET_PASSWORD_CMS_QUERY,
  QUERY_GET_FORM_CMS_CONTENT,
  GET_REGISTER_PAGE_CMS_QUERY,
  getMetaTitle,
]);
export default withApollo(RegisterPage);
